import { createFileRoute } from "@tanstack/react-router"
import { lazyImportRouteComponent } from "../../../../utils/lazyImportRouteComponent"

export const Route = createFileRoute("/app/admin-settings/info/")({
  component: lazyImportRouteComponent(
    () => import("./-components/InfoPage"),
    "InfoPage"
  ),
})
